import { Injectable } from '@angular/core';
import { ClassificationsResponse, FuelsResponse, IVehiclesService, PlateResponse, Vehicle, VehicleRquest, VehicleTypeResponse, VehiclesResponse } from './vehicles.interface';
import { Observable, of, tap } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { LanguageUtils } from '../../utils/language.utils';
import { environment } from '../../../../environments/environment';
import { AuthService } from '../../auth/auth.service';
import { CodeName } from '../common.http.interface';

@Injectable({
  providedIn: 'root'
})
export class VehiclesService implements IVehiclesService {
  cache = new Map<string, VehicleTypeResponse>();

  constructor(
    private httpClient: HttpClient,
    private readonly authService: AuthService
  ) { }

  getVehiclees(limit = 10, offset = 0): Observable<VehiclesResponse> {
    return this.httpClient.get<VehiclesResponse>(environment.apiPublicUrl + '/registration/applicant/vehicles?applicant=' + this.authService.getCurrentUser().documentNumber + '&limit=' + limit + '&offset=' + offset + '&language=' + LanguageUtils.getLanguage());
  }
  getVehicleesByApplicant(applicantId: string, limit = 10, offset = 0): Observable<VehiclesResponse> {
    return this.httpClient.get<VehiclesResponse>(environment.apiPublicUrl + '/registration/applicant/vehicles?applicant=' + applicantId + '&limit=' + limit + '&offset=' + offset + '&language=' + LanguageUtils.getLanguage());
  }
  getVehicle(plate: string): Observable<Vehicle> {
    return this.httpClient.get<Vehicle>(environment.apiPublicUrl + '/registration/applicant/vehicle?applicant=' + this.authService.getCurrentUser().documentNumber + '&vehicle=' + plate + '&language=' + LanguageUtils.getLanguage());
  }
  addVehicle(newVehicle: VehicleRquest): Observable<Vehicle> {
    return this.httpClient.post<Vehicle>(
      environment.apiPublicUrl + '/registration/applicant/vehicle?applicant=' + this.authService.getCurrentUser().documentNumber + '&language=' + LanguageUtils.getLanguage(),
      newVehicle,
      {
        headers: {
          'Content-Type': 'application/json'
        }
      });
  }
  addVehicles(newVehicles: VehicleRquest[]): Observable<Vehicle[]> {
    return this.httpClient.post<Vehicle[]>(
      environment.apiPublicUrl + '/registration/applicant/vehicles?applicant=' + this.authService.getCurrentUser().documentNumber + '&language=' + LanguageUtils.getLanguage(),
      newVehicles,
      {
        headers: {
          'Content-Type': 'application/json'
        }
      });
  }
  addVehiclesByApplicant(newVehicles: VehicleRquest[], documentNumber: string): Observable<Vehicle[]> {
    return this.httpClient.post<Vehicle[]>(
      environment.apiPublicUrl + '/registration/applicant/vehicles?applicant=' + documentNumber + '&language=' + LanguageUtils.getLanguage(),
      newVehicles,
      {
        headers: {
          'Content-Type': 'application/json'
        }
      });
  }
  updateVehicle(vehicleToUpdate: Vehicle): Observable<Vehicle> {
    return this.httpClient.post<Vehicle>(
      environment.apiPublicUrl + '/registration/applicant/vehicle?applicant=' + this.authService.getCurrentUser().documentNumber + '&language=' + LanguageUtils.getLanguage(),
      {
        vehiclePlate: vehicleToUpdate.vehiclePlate,
        vehicleAlias: vehicleToUpdate.vehicleAlias
      },
      {
        headers: {
          'Content-Type': 'application/json'
        }
      });
  }
  deleteVehicle(vehiclePlate: string): Observable<string> {
    return this.httpClient.delete<string>(environment.apiPublicUrl + '/registration/applicant/vehicle?applicant=' + this.authService.getCurrentUser().documentNumber + '&vehicle=' + vehiclePlate + '&language=' + LanguageUtils.getLanguage());
  }
  deleteVehicleByApplicant(vehiclePlate: string, documentNumber: string): Observable<string> {
    return this.httpClient.delete<string>(environment.apiPublicUrl + '/registration/applicant/vehicle?applicant=' + documentNumber + '&vehicle=' + vehiclePlate + '&language=' + LanguageUtils.getLanguage());
  }
  getVehicleTypes(): Observable<VehicleTypeResponse> {
    const cached = this.cache.get(LanguageUtils.getLanguage());
    if (cached) {
      return of(cached);
    } else {
      return this.httpClient.get<VehicleTypeResponse>(environment.apiPublicUrl + '/registration/vehicles/types?language=' + LanguageUtils.getLanguage()).pipe(
        tap(data => this.cache.set(LanguageUtils.getLanguage(), data))
      );
    }
  }

  checkPlate(plate: string): Observable<PlateResponse> {
    return this.httpClient.get<PlateResponse>(environment.apiPublicUrl + '/vehicle?plate=' + plate + '&language=' + LanguageUtils.getLanguage());
  }

  getClassifications(): Observable<ClassificationsResponse> {
    // https://{{server}}:8002/zbe/exceptions/vehicles/classifications?language=ca-ES
    return this.httpClient.get<ClassificationsResponse>(environment.apiPublicUrl + '/vehicles/classifications?language=' + LanguageUtils.getLanguage());
  }
  getFuels(): Observable<FuelsResponse> {
    // https://{{server}}:8002/zbe/exceptions/vehicles/fuels?language=ca-ES
    return this.httpClient.get<FuelsResponse>(environment.apiPublicUrl + '/vehicles/fuels?language=' + LanguageUtils.getLanguage());
  }
}
